import { useEffect, useState } from 'react';
import { Pressable, View } from 'react-native';
import { Flex, Typography, IconClose, ColorValues } from '@banhala/ui-kit';
import { localStorageBridge } from 'shared/src/utils';

// SearchHelper 툴팁과 동일 키 공유 — 한쪽에서 닫으면 양쪽 모두 숨김
const STORAGE_KEY = 'SHOULD_SHOW_SEARCH_CAMERA_SEARCH_TOOLTIP';

export const SearchResultCameraTooltip = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    (async () => {
      const shouldShow = await localStorageBridge.getBoolean(STORAGE_KEY);
      setVisible(shouldShow ?? true);
    })();
  }, []);

  const hideTooltip = () => {
    localStorageBridge.putBoolean(STORAGE_KEY, false);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Pressable onPress={hideTooltip}>
      <Flex alignItems="flex-end">
        {/* iOS: upTailImageView, tintColor = bg_pink_primary */}
        <View
          style={{
            width: 10,
            height: 10,
            backgroundColor: ColorValues.pink30,
            transform: [{ rotate: '45deg' }],
            marginRight: 22,
            marginBottom: -5,
            borderTopLeftRadius: 1,
          }}
        />

        {/* iOS: bubbleContainerView, cornerRadius 4, height 28 */}
        <Flex.Row
          backgroundColor="bg_pink_primary"
          borderRadius={4}
          padding={{ horizontal: 8, vertical: 6 }}
          alignItems="center"
        >
          <Typography
            type="body4"
            color="content_always_white"
            numberOfLines={1}
          >
            사진으로 상품을 검색해보세요!
          </Typography>
          <Flex margin={{ left: 2 }}>
            <IconClose fill={ColorValues.white} size={16} />
          </Flex>
        </Flex.Row>
      </Flex>
    </Pressable>
  );
};
